<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left>
        <a class="link color-theme-white popup-close" href="#">
          <i class="icon icon-back"></i>
          <span>返回</span>
        </a>
      </f7-nav-left>
      <f7-nav-title>分包范围</f7-nav-title>
      <f7-nav-right>
        <f7-link popup-close>&nbsp;确定</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content">
      <div class="selected-area">
        <div class="selected-label">已选择分包范围</div>
        <div class="chip" style="max-width: 100%;" v-for="item in selectedList" :key="item">
          <div class="chip-label" style="max-width: 95%;">{{ item }}</div>
          <a href="#" class="chip-delete" @click="deleteScope"></a>
        </div>
      </div>
      <div class="custom-scope">
        <form
          class="searchbar searchbar-custom"
          id="searchbar-custom">
          <div class="searchbar-inner">
            <div class="searchbar-input-wrap">
              <input
                type="search"
                placeholder="自定义范围"
                :value="name"
                @change="inputVal">
              <span class="input-clear-button"></span>
            </div>
          </div>
        </form>
        <div class="add-button">
          <f7-link @click="addCustom">
            <span class="add-text">添加</span>
          </f7-link>
        </div>
      </div>
      <div class="scope-default">
        <div
          class="item-scope"
          v-for="(item, index) in scopeList"
          :key="item.code">
          <div class="item-title">
            <f7-checkbox
              :value="item.name"
              :checked="selectedList.indexOf(`${item.name}`) >= 0"
              @change="selectedVal(item.name, $event)">
            </f7-checkbox>
            <div style="width: 0.5rem;"></div>
            <div style="flex: auto;">{{ item.name }}</div>
            <div>
              <f7-link
                 class="item-title-icon"
                :icon-fa="item.expanded ? 'angle-up' : 'angle-right'"
                @click="toggleExpanded(item, index)">
              </f7-link>
            </div>
          </div>
          <div
            v-for="sub in item.children"
            :key="sub.code"
            v-show="item.expanded">
            <div class="sub-titile">
              <f7-checkbox
                :value="`${item.name}/${sub.name}`"
                :checked="selectedList.indexOf(`${item.name}/${sub.name}`) >= 0"
                @change="selectedVal(item.name, $event)">
              </f7-checkbox>
              <div style="width: 0.5rem;"></div>
              <div>{{ sub.name }}</div>
            </div>
            <div class="grandson">
              <div
                class="grandson-button"
                v-for="grandson in sub.children"
                :key="grandson.code">
                <button
                  :class="selectedList.indexOf(`${item.name}/${sub.name}/${grandson.name}`) >= 0 ?
                  'button button-checked' : 'button button-unchecked'"
                  @click="toggleButton(`${item.name}/${sub.name}/${grandson.name}`)">
                  {{ grandson.name }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import lodash from 'lodash';
import { dateFormat } from '@/util/dateUtils';
import { getDictListByGroup } from '@/api/common';

export default {
  props: ['dictKey', 'result', 'opened'],
  data() {
    return {
      selectedList: this.result || [],
      scopeList: [],
      name: '',
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    dictKey(newVal) {
      this.selectedList = this.result || [];
      this.getList(newVal);
    },
    opened(newVal) {
      if (newVal) {
        this.selectedList = this.result || [];
      }
    },
    selectedList(newVal) {
      this.$emit('update:result', newVal);
    },
  },
  filters: {
    formatDateValue: value => dateFormat(value, 'YYYY-MM-DD HH:mm'),
  },
  methods: {
    inputVal(event) {
      this.name = event.target.value;
    },
    selectedVal(parent, event) {
      const value = event.target.value;
      if (event.target.checked) {
        const obj = this.selectedList.find(item => item === value);
        if (!obj) {
          this.selectedList.push(value);
        }
      } else {
        const index = this.selectedList.findIndex(item => item === value);
        if (index >= 0) {
          this.selectedList.splice(index, 1);
        }
      }
    },
    toggleExpanded(item, index) {
      Object.assign(item, { expanded: !item.expanded });
      this.$set(this.scopeList, index, item);
    },
    toggleButton(value) {
      const index = this.selectedList.findIndex(item => item === value);
      if (index >= 0) {
        this.selectedList.splice(index, 1);
      } else {
        this.selectedList.push(value);
      }
    },
    getList(newVal) {
      const key = newVal || this.dictKey;
      if (lodash.isEmpty(key)) {
        return;
      }
      const dictKeys = [key];
      getDictListByGroup({ groups: dictKeys }).then((result) => {
        if (result.code === 0) {
          this.scopeList = ((result.data[this.dictKey] || {}).codeVoList || [])
            .map((item, index) => {
              let expanded = false;
              if (index === 0) {
                expanded = true;
              }
              return Object.assign(item, { expanded });
            });
        }
      });
    },
    addCustom() {
      if (lodash.isEmpty(this.name)) {
        return;
      }
      const index = this.selectedList.findIndex(item => item === this.name);
      if (index < 0) {
        this.selectedList.push(this.name);
      }
      this.name = '';
    },
    deleteScope(e) {
      const value = this.$$(e.target).parents('.chip').children('.chip-label').text();
      const index = this.selectedList.findIndex(item => item === value);
      if (index >= 0) {
        this.selectedList.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  @import '~@/style/app-var.scss';

  .selected-area {
    padding-bottom: 1rem;
    border-bottom: 0.05rem solid $border-color;
  }

  .selected-label {
    padding: 0.5rem 0rem;
    font-size: 1rem;
  }

  .custom-scope {
    display: flex;
    align-items: center;
    padding: 1rem 0rem;
  }

  .searchbar-custom {
    height: 32px;
    background: $white-color;
    flex: auto;
  }

  .add-button {
    padding: 0rem 0rem 0rem 1rem;
    width: 3rem;
    font-size: 1rem;
  }

  .add-text {
    color: $theme-color;
  }

  .item-scope {
    margin:  0.5rem 0rem;
  }

  .item-title {
    display: flex;
    align-items: center;
    margin: 0rem 0rem;
    padding: 0rem 0.5rem;
    background-color: #EEEEEE;
    color: $font-color;
    font-size: 1rem;
  }

  .item-title-icon {
    color: $second-font-color;
    padding: 0.5rem 0.8rem;
  }

  .sub-titile {
    padding: 0.5rem 0.5rem;
    display: flex;
    align-items: center;
    font-size: 0.8rem;
  }

  .grandson {
    padding: 0rem 0.5rem 0rem 2rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .grandson-button {
    padding: 0rem 0.5rem 0.5rem 0rem;
  }

  .button-checked {
    border-color: $second-color;
    background-color: $second-color;
    color: $white-color;
  }

  .button-unchecked {
    border-color: $second-color;
    background-color: $white-color;
    color: $second-color;
  }

</style>



// WEBPACK FOOTER //
// src/components/Scope.vue